import useToggleState from '@lib/hooks/use-toggle-state'
import { searchClient, SEARCH_INDEX_NAME } from '@lib/search-client'
import Modal from '@modules/common/components/modal'
import Search from '@modules/common/icons/search'
import DesktopHit from '@modules/search/components/desktop-hit'
import DesktopHits from '@modules/search/components/desktop-hits'
import SearchBox from '@modules/search/components/search-box'
import { Configure, InstantSearch } from 'react-instantsearch'

const DesktopSearchModal = () => {
  const { state, close, open } = useToggleState()

  return (
    <>
      <button onClick={open} className="px-2 text-xs flex items-center gap-x-2 xs:w-8 sm:w-28 h-3/6 bg-gray-50 rounded-md">
        <Search />
        <span className="xs:hidden">Search</span>
      </button>

      <Modal isOpen={state} close={close} size="large">
        <Modal.Body>

          <InstantSearch
            indexName={SEARCH_INDEX_NAME}
            searchClient={searchClient}
          >

            <Configure
              analytics={false}
              filters="tags_value = store"
              hitsPerPage={40}
            />

            <div className="flex flex-col h-full">
              <div className="w-full flex items-center gap-x-2 bg-gray-50 p-4">
                <Search />
                <SearchBox />
              </div>

              <div className="overflow-y-scroll flex-1 no-scrollbar mt-6">
                <DesktopHits hitComponent={DesktopHit} />
              </div>
            </div>
          </InstantSearch>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default DesktopSearchModal
